import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as logger from 'universal-logger';
import * as defaultModuleMap from './modules'; // TODO: move all of this into cms-modules.saga

var getModuleName = function getModuleName(moduleDef) {
  return (moduleDef.type || '').toLowerCase();
};

export var findModule = function findModule(moduleMap, moduleDef) {
  var moduleName = getModuleName(moduleDef);
  var module = moduleMap[moduleName] || null;

  if (!module) {
    logger.warn("module [".concat(moduleName, "] is unknown"));
  }

  return module;
};

var moduleMapper = function moduleMapper(moduleMap, state, modules) {
  return (modules || []).map(function (moduleDef) {
    return [findModule(moduleMap, moduleDef), moduleDef];
  }).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        module = _ref2[0];

    return module;
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        module = _ref4[0],
        moduleDef = _ref4[1];

    // This is disappearing in an upcoming PR,
    // since all modules will map themselves via
    // mapStateToProps.
    var props = module.propMapper ? module.propMapper(state, moduleDef) : moduleDef;
    var propModules = props.modules || props.items;
    return {
      Component: module,
      cmsModuleId: moduleDef.contentfulId,
      props: propModules ? _objectSpread({}, props, {
        modules: moduleMapper(moduleMap, state, propModules)
      }) : props
    };
  });
};

export var cmsDataToModuleArray = function cmsDataToModuleArray(state, cmsData) {
  var moduleMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultModuleMap;
  return moduleMapper(moduleMap, state, cmsData.modules);
};